import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import api from '../../utils/api';
import useTheme from '../../hooks/useTheme';

const ForgotPassword = () => {
    const { theme } = useTheme();
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const { register, handleSubmit, formState: { errors } } = useForm();

    const onSubmit = async (data) => {
        setLoading(true);
        setError('');
        try {
            await api.post('/auth/forgot-password', data);
            setSuccess(true);
        } catch (err) {
            setError(err.response?.data?.error || 'Error procesando solicitud');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--color-fondo)' }}>
            <div className="bg-white rounded-2xl shadow-lg p-10 w-full max-w-md">
                <div className="flex flex-col items-center mb-8">
                    <div
                        className="w-16 h-16 rounded-full flex items-center justify-center text-white text-2xl font-bold mb-3"
                        style={{ backgroundColor: 'var(--color-primary)' }}
                    >
                        {theme.empresa_nombre?.charAt(0)}
                    </div>
                    <h1 className="text-2xl font-bold text-gray-800">Recuperar contraseña</h1>
                    <p className="text-gray-500 text-sm mt-1 text-center">
                        Ingresa tu correo y te enviaremos las instrucciones
                    </p>
                </div>

                {success ? (
                    <div className="bg-green-50 border border-green-200 text-green-700 rounded-lg px-4 py-4 text-sm text-center">
                        Si el correo existe en el sistema, recibirás las instrucciones en tu bandeja de entrada.
                    </div>
                ) : (
                    <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Correo electrónico
                            </label>
                            <input
                                type="email"
                                {...register('email', { required: 'El correo es requerido' })}
                                className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none"
                                placeholder="correo@empresa.com"
                            />
                            {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email.message}</p>}
                        </div>

                        {error && (
                            <div className="bg-red-50 border border-red-200 text-red-600 text-sm rounded-lg px-4 py-3">
                                {error}
                            </div>
                        )}

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full text-white font-semibold py-2.5 rounded-lg transition-opacity disabled:opacity-60"
                            style={{ backgroundColor: 'var(--color-primary)' }}
                        >
                            {loading ? 'Enviando...' : 'Enviar instrucciones'}
                        </button>

                        <div className="text-center">
                            <a href="/login" className="text-sm hover:underline" style={{ color: 'var(--color-primary)' }}>
                                Volver al login
                            </a>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

export default ForgotPassword;
